module.exports = ".jumbotronImg{\n    background-image: url('faded-active-aerobics-asian-2200.png');\n    background-size: cover;\n}\n\n"